import { CardFooter, CardFooterProps } from "reactstrap"
import styled from "@emotion/styled"

export type TooltipFooterProps = CardFooterProps

export const TooltipFooter = styled(CardFooter)`
  background: white;
`
